// Default placeholder text for a freshly-added textbox. Historically
// FR-only literal — a translation key `default_text_placeholder`
// exists in fr.json / en.json but was never wired.
const DEFAULT_TEXTBOX_TEXT = 'Votre texte';

export { DEFAULT_TEXTBOX_TEXT };
